import React from "react";

const FeedbackForm = ({ setModalVisible }) => {
  const body = document.querySelector("body")
  const closeModal = () => {
    setModalVisible(false)
    body.classList.remove("overflow-hidden");
  };
  return (
    <div className="text-gray-700 flex-col flex">
      <h1 className="mb-5 text-4xl font-bold">Thank you</h1>
      <p className="text-lg mb-8">We appreciate the feedback</p>
      <button
        onClick={closeModal}
        className="self-end bg-grey-light font-bold text-lg py-2 px-4 rounded"
      >
        OK
      </button>
    </div>
  );
};

export default FeedbackForm;
